module.exports = __webpack_public_path__ + "img/big3-6.133b7530.jpg";